import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast'
import Backdrop from '@mui/material/Backdrop';
import { Dropdown } from 'primereact/dropdown'
import CircularProgress from '@mui/material/CircularProgress';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { InputTextarea } from 'primereact/inputtextarea';
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import TituloAtividadeFaseService from '../../app/service/TituloAtividadeFaseService'
import FaseTerefaService from '../../app/service/FaseTarefaService'
import UsuarioService from '../../app/service/UsuarioService'
import ProjecaoUsuarioService from '../../app/service/ProjecaoUsuarioService'
import CheckListAtividadeService from '../../app/service/CheckListAtividadeService'
import FaseService from '../../app/service/FaseService'

class TituloAtividade extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      titulo: null,
      titulos: [],
      codigo: '',
      nome: '',
      pontos: '',
      status: null,
      modalTitulo: false,
      modalTituloAlterar: false,
      openSpinner: false,
      //TitulosFases
      fases: [],
      fasesCadastro: [],
      fase: null,
      modalFase: false,
      modalProjecao: false,
      projecoes: [],
      projecao: null,
      usuarios: [],
      usuario: null,
      usuarioNome: '',
      pontosUsuario: '',
      ano: '',
      mes: '',
      modalCadastroProjecao: false,
      modalAlterarProjecao: false,
      //Filtros das projeções
      filtroNome: '',
      filtroAno: '',
      filtroMes: '',
      //CheckList de atividades
      checkListLista: [],
      checkList: null,
      codigoCheckList: '',
      tarefaCheckList: '',
      ordemChecklist: '',
      descricaoCheckList: '',
      modalCheckList: false,
      modalCadastrarCheckList: false,
      modalAlterarCheckjList: false,
      //Fases do processo associados aos títulos
      fasesProcesso: [],
      faseProcesso: null,
      //Filtros e Ordenação
      filtroNome: '',
      filtroStatus: null,
      filtroStatus: null,
      filtroFase: null,
      classificacao: null,
      ordenacao: null,
    }

    this.classificacao = [
      {codigo: '1', nome: 'Nome'},
      {codigo: '2', nome: 'Fase'},
      {codigo: '3', nome: 'Pontos'}
    ];

    this.ordenacao = [
      {codigo: '1', nome: 'Ascendente'},
      {codigo: '2', nome: 'Decrescente'}
    ];

    this.status = [
      {codigo: 'A', nome: 'Ativo'},
      {codigo: 'I', nome: 'Inativo'}
    ];

    this.tituloAtividadeService = new TituloAtividadeService();
    this.tituloAtividadeFaseService = new TituloAtividadeFaseService();
    this.faseTarefaService = new FaseTerefaService();
    this.usuarioService = new UsuarioService();
    this.projecaoUsuarioService = new ProjecaoUsuarioService();
    this.checkListAtividadeService = new CheckListAtividadeService();
    this.faseService = new FaseService();

    this.acoes = this.acoes.bind(this);
    this.accept = this.accept.bind(this);
    this.renderFooterCadastroTitulos = this.renderFooterCadastroTitulos.bind(this);
    this.renderFooterAlterarTitulos = this.renderFooterAlterarTitulos.bind(this);
    this.renderFooterFase = this.renderFooterFase.bind(this);
    this.acoesfase = this.acoesfase.bind(this);
    this.onChangeCadastrarFase = this.onChangeCadastrarFase.bind(this);
    this.onChangeConsultarTitulosPorFase = this.onChangeConsultarTitulosPorFase.bind(this);
    this.onChangeConsultarTitulosPorStatus = this.onChangeConsultarTitulosPorStatus.bind(this);
    this.onChangeConsultarTitulosPorClassificacao = this.onChangeConsultarTitulosPorClassificacao.bind(this);
    this.onChangeConsultarTitulosPorOrdenacao = this.onChangeConsultarTitulosPorOrdenacao.bind(this);
    this.renderFooterProjecao = this.renderFooterProjecao.bind(this);
    this.renderFooterCadastroProjecao = this.renderFooterCadastroProjecao.bind(this);
    this.acoesProjecoes = this.acoesProjecoes.bind(this);
    this.acceptExcluirProjecao = this.acceptExcluirProjecao.bind(this);
    this.renderFooterAlterarProjecao = this.renderFooterAlterarProjecao.bind(this);
    this.renderFooterChekList = this.renderFooterChekList.bind(this);
    this.renderFooterCadastrarChekList = this.renderFooterCadastrarChekList.bind(this);
    this.acoesCheckList = this.acoesCheckList.bind(this);
    this.renderFooterAlterarChekList = this.renderFooterAlterarChekList.bind(this);
  }

  listarFases = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.faseService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fasesProcesso: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Projeção Usuarios', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarUsuario = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuarios: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Projeção Usuarios', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarProjecoes = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: '',
      ano: '2023',
      mes: '0'
    }
    await this.projecaoUsuarioService.listar(filtro)
      .then(response => {
        this.setState({projecoes: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Projeção Usuarios', detail:`${this.state.detail}`, life: 4000});
      });
  }

  filtrarProjecoes = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      usuario: this.state.filtroNome,
      ano: this.state.filtroAno,
      mes: this.state.filtroMes
    }
    
    this.setState({openSpinner: true});
    await this.projecaoUsuarioService.listar(filtro)
      .then(response => {
        this.setState({projecoes: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Projeção Usuarios', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
  }

  consultarProjecoes = async () => {
    this.setState({openSpinner: true});
    await this.listarProjecoes();
    this.setState({openSpinner: false});
    this.abrirModa('modalProjecao');
  }

  cadastrarProjecaoTela = async () => {
    this.setState({usuario: null});
    this.setState({ano: ''});
    this.setState({pontos: ''});
    this.setState({openSpinner: true});
    await this.listarUsuario();
    this.setState({openSpinner: false});
    this.abrirModa('modalCadastroProjecao');
  }

  cadastrarProjecao = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.usuario == null) {
      this.toast.show({severity:'error', summary: 'Projeção de Usuários', detail:'Informe o usuário', life: 4000});
      return;
    }

    if(this.state.ano == '') {
      this.toast.show({severity:'error', summary: 'Projeção de Usuários', detail:'Informe o ano para a projeção', life: 4000});
      return;
    }

    if(this.state.mes == '') {
      this.toast.show({severity:'error', summary: 'Projeção de Usuários', detail:'Informe o mês para a projeção', life: 4000});
      return;
    }

    if(this.state.pontosUsuario == '') {
      this.toast.show({severity:'error', summary: 'Projeção de Usuários', detail:'Informe os pontos', life: 4000});
      return;
    }

    const projecao = {
      usuario: this.state.usuario,
      ano: this.state.ano,
      mes: this.state.mes,
      pontos: this.state.pontosUsuario,
      empresa: usuarioLogado.empresa
    };

    this.setState({openSpinner: true});
    await this.projecaoUsuarioService.cadastrar(projecao)
      .then(response => {
        this.listarProjecoes();
        this.fecharModal('modalCadastroProjecao');
        this.toast.show({severity:'success', summary: 'Projeção de Usuários', detail:'Projeção cadastrada com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Projeção Usuarios', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  alterarProjecaoUsuario = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.usuario == null) {
      this.toast.show({severity:'error', summary: 'Projeção de Usuários', detail:'Informe o usuário', life: 4000});
      return;
    }

    if(this.state.ano == '') {
      this.toast.show({severity:'error', summary: 'Projeção de Usuários', detail:'Informe o ano para a projeção', life: 4000});
      return;
    }

    if(this.state.pontosUsuario == '') {
      this.toast.show({severity:'error', summary: 'Projeção de Usuários', detail:'Informe os pontos', life: 4000});
      return;
    }

    const projecao = {
      codigo: this.state.projecao.codigo,
      usuario: this.state.usuario,
      ano: this.state.ano,
      mes: this.state.mes,
      pontos: this.state.pontosUsuario,
      empresa: usuarioLogado.empresa
    }

    this.setState({openSpinner: true});
    await this.projecaoUsuarioService.alterar(projecao)
      .then(response => {
        this.listarProjecoes();
        this.fecharModal('modalAlterarProjecao');
        this.toast.show({severity:'success', summary: 'Projeção de Usuários', detail:'Projeção alterada com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Projeção Usuarios', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  listarUsuariosShorts = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.usuarioService.listarShorts(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuarios: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Projeção Usuarios', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarProjecaoUsuario(projecao) {
    this.setState({openSpinner: true});
    await this.projecaoUsuarioService.consultar(projecao.codigo)
      .then(response => {
        this.setState({projecao: response.data});
        this.setState({usuario: response.data.usuario});
        this.setState({usuarioNome: response.data.usuario.nome});
        this.setState({ano: response.data.ano});
        this.setState({mes: response.data.mes});
        this.setState({pontosUsuario: response.data.pontos});
        this.abrirModa('modalAlterarProjecao');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Projeção Usuarios', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  confirmacaoExclusaoProjecao(projecao) {
    this.setState({projecao: projecao});
    confirmDialog({
        message: 'Deseja realmente excluir esta projeção de usuário?',
        header: 'Exclusão de rojeção de Usuário',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirProjecao,
        reject: this.reject
    });
  }

  acceptExcluirProjecao = async () => {
    this.setState({openSpinner: true});
    await this.projecaoUsuarioService.excluir(this.state.projecao.codigo)
      .then(response => {
        this.listarProjecoes();
        this.toast.show({severity:'success', summary: 'Projeção de Usuários', detail:'Projeção excluída com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Projeção Usuarios', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  listrFasesPorTitulos = async () => {
    await this.tituloAtividadeFaseService.listar(this.state.titulo.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarFasesNotInTitulo = async (titulo) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeFaseService.listarNotInTitulo(titulo,usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fasesCadastro: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  associarFaseTitulo = async () => {
    if(this.state.fase == null) {
      this.toast.show({severity:'error', summary: 'Fase Título', detail:'Informe a Fase', life: 4000});
      return;
    }

    const tituloFase ={
      titulo: this.state.titulo,
      fase: this.state.fase
    };

    await this.tituloAtividadeFaseService.cadastrar(tituloFase)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Fase Título', detail:'Fase associada ao Título com sucesso', life: 4000});
        this.listrFasesPorTitulos();
        this.listarFasesNotInTitulo(this.state.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async associarFaseTituloNovo(titulo){
    this.setState({openSpinner: true});
    await this.consultarTituloCadastroFase(titulo);
    this.setState({fase: null});
    await this.listrFasesPorTitulos();
    await this.listarFasesNotInTitulo(titulo.codigo);
    this.abrirModaAlterar('modalFase');
    this.setState({openSpinner: false})
  }

  async onChangeCadastrarFase(e) {
    await this.setState({fase: e.value});
    this.setState({openSpinner: true});
    await this.associarFaseTitulo();
    this.setState({openSpinner: false});
  }

  async onChangeConsultarTitulosPorFase(e) {
    await this.setState({filtroFase: null});
    if(e.value != null) {
      this.setState({filtroFase: e.value});
    }
    await this.filtrarTitulos();
  }

  async onChangeConsultarTitulosPorStatus(e) {
    await this.setState({filtroStatus: null});
    if(e.value != null) {
      this.setState({filtroStatus: e.value});
    }
    await this.filtrarTitulos();
  }

  async onChangeConsultarTitulosPorClassificacao(e) {
    await this.setState({classificacao: null});
    if(e.value != null) {
      this.setState({classificacao: e.value});
    }
    await this.filtrarTitulos();
  }

  async onChangeConsultarTitulosPorOrdenacao(e) {
    await this.setState({ordenacao: null});
    if(e.value != null) {
      this.setState({ordenacao: e.value});
    }
    await this.filtrarTitulos();
  }

  consultarPorTitulo = async () => {
    this.filtrarTitulos();
  }

  filtrarTitulos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    
    var classificacao = 1;
    var ordenacao = 1;
    var status = 'A' ;
    var fase = 0;

    if(this.state.filtroFase != null) {
      fase = this.state.filtroFase.codigo;
    }
    
    if(this.state.classificacao != null) {
      classificacao = this.state.classificacao.codigo;
    }

    if(this.state.ordenacao != null) {
      ordenacao = this.state.ordenacao.codigo;
    }

    if(this.state.filtroStatus != null) {
      status = this.state.filtroStatus.codigo;
    }

    if(this.state.filtroFase != null) {
      fase = this.state.filtroFase.codigo
    }

    const filtro = {
      empresa: usuarioLogado.empresa.codigo,
      titulo: this.state.filtroNome,
      fase: fase,
      status: status,
      classificacao: classificacao,
      ordenacao: ordenacao
    }

    this.setState({openSpinner: true});
    await this.tituloAtividadeService.consultarTitulos(filtro)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner: false});
      });
      this.setState({openSpinner: false});
  }

  listarTitulos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  telaTituloAtividade = async () => {
    this.limparCampos();
    this.setState({openSpinner: true});
    await this.listarFases();
    this.setState({openSpinner: false});
    this.abrirModa('modalTitulo')
  }

  abrirModa(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  async limparCampos() {
    this.setState({faseProcesso: null});
    this.setState({titulo: null});
    this.setState({nome: ''});
    this.setState({pontos: ''});

  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarTitulo(rowData)}
                tooltip="Editar Título" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-list" className="p-button-rounded p-button-text"
                onClick={() => this.exibirCheckList(rowData)}
                tooltip="Check List de Atividades" 
                tooltipOptions={{position: 'top'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusao(rowData)} 
                tooltip="Excluir Título" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  acoesProjecoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarProjecaoUsuario(rowData)}
                tooltip="Editar projeção" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmacaoExclusaoProjecao(rowData)} 
                tooltip="Excluir Projeção" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  acoesfase(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.excluirFase(rowData)} 
                tooltip="Excluir Fase" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  async excluirFase(fase) {
    this.setState({openSpinner: true});
    await this.tituloAtividadeFaseService.excluir(this.state.titulo.codigo,fase.codigo)
      .then(response => {
        this.listrFasesPorTitulos();
        this.listarFasesNotInTitulo(this.state.codigo);
        this.toast.show({severity:'success', summary: 'Fase Título', detail:'Fase excluída com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Fase Título', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  confirmaExclusao(titulo) {
    this.setState({codigo: titulo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o Título de Atividade selecionado?',
        header: 'Exclusão de Título de Atividade',
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.accept,
        reject: this.reject
    });
  }

  excluirTitulo() {
    this.setState({openSpinner: true});
    this.tituloAtividadeService.excluir(this.state.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Títulos de Atividades', detail:'Título de Atividade excluído com sucesso', life: 4000});
        this.listarTitulos();
      });
      this.setState({openSpinner: false});
  }

  accept() {
    this.excluirTitulo();
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModaAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }

    this.setState(state);
  }

  renderFooterCadastroTitulos(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarTitulo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarTitulos(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarTitulo}/> 
            &nbsp;
            <Button label="Cancelar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterFase(name) {
    return (
        <div>
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterProjecao(name) {
    return (
        <div>
            <Button label="Incluir" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarProjecaoTela}/> 
            &nbsp;
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterCadastroProjecao(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarProjecao}/> 
            &nbsp;
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarProjecao(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarProjecaoUsuario}/> 
            &nbsp;
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  async consultarTitulo(titulo){
    this.setState({openSpinner: true});
    await this.tituloAtividadeService.consultar(titulo.codigo)
      .then(response => {
        this.setState({titulo: response.data});
        this.setState({nome: response.data.titulo});
        this.setState({codigo: response.data.codigo});
        this.setState({pontos: response.data.pontos});
        this.setState({faseProcesso: response.data.fase});
        if(response.data.status == 'Ativo') {
          this.setState({status: {
            codigo: 'A',
            nome: 'Ativo'
          }});
        } else {
          this.setState({status: {
            codigo: 'I',
            nome: 'Inativo'
          }});
        }
        this.listarFases();
        this.abrirModaAlterar('modalTituloAlterar');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async consultarTituloCadastroFase(titulo){
    this.setState({openSpinner: true});
    await this.tituloAtividadeService.consultar(titulo.codigo)
      .then(response => {
        this.setState({titulo: response.data});
        this.setState({nome: response.data.titulo});
        this.setState({codigo: response.data.codigo});
        this.setState({pontos: response.data.pontos});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarTitulo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'O nome do Título da Atividade é obrigatório', life: 4000});
      return;
    }

    if(this.state.pontos == '') {
      this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'Informe um valor de pontos', life: 4000});
      return;
    }

    const titulo = {
      titulo: this.state.nome,
      empresa: usuarioLogado.empresa,
      pontos: this.state.pontos,
      fase: this.state.faseProcesso
    }

    this.setState({openSpinner: true});
    await this.tituloAtividadeService.cadastrar(titulo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Títulos de Atividades', detail:'Título de Atividade cadastrado com sucesso', life: 4000});
        this.fecharModal('modalTitulo');
        this.listarTitulos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  alterarTitulo = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.nome == '') {
      this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'O nome do Título da Atividade é obrigatório', life: 4000});
      return;
    }

    const titulo = {
      codigo: this.state.codigo,
      titulo: this.state.nome,
      empresa: usuarioLogado.empresa,
      pontos: this.state.pontos,
      fase: this.state.faseProcesso,
      status: this.state.status.codigo
    }

    this.setState({openSpinner: true});
    await this.tituloAtividadeService.alterar(titulo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Títulos de Atividades', detail:'Título de Atividade alterado com sucesso', life: 4000});
        this.fecharModal('modalTituloAlterar');
        this.listarTitulos();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  cadastrarCheckList = async () => {
    if(this.state.ordemChecklist == '') {
      this.toast.show({severity:'error', summary: 'Check List de Atividades', detail:'Informe a ordem da tarefa', life: 4000});
      return;
    }

    if(this.state.tarefaCheckList == '') {
      this.toast.show({severity:'error', summary: 'Check List de Atividades', detail:'Informe a tarefa', life: 4000});
      return;
    }

    const checklist = {
      atividade: {
        codigo: this.state.codigo
      },
      ordem: this.state.ordemChecklist,
      tarefa: this.state.tarefaCheckList,
      descricao: this.state.descricaoCheckList
    }
    this.setState({openSpinner: true});
    await this.checkListAtividadeService.cadastrar(checklist)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Check List de Atividades', detail:'Ítem de Checklist cadastrado com sucesso', life: 4000});
        this.atualizarCheckList(this.state.codigo);
        this.fecharModal('modalCadastrarCheckList');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Check List de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  incluirCheckList = () => {
    this.limparCheckList();
    this.abrirModa('modalCadastrarCheckList');
  }

  limparCheckList = () => {
    this.setState({tarefaCheckList: ''});
    this.setState({descricaoCheckList: ''});
    this.setState({ordemChecklist: ''});
  }

  async exibirCheckList(atividade) {
    this.setState({openSpinner: true});
    await this.checkListAtividadeService.listar(atividade.codigo)
      .then(response => {
        this.setState({nome: atividade.titulo})
        this.setState({codigo: atividade.codigo});
        this.setState({checkListLista: response.data});
        this.abrirModa('modalCheckList');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Check List de Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
  }

  atualizarCheckList = async (atividade) => {
    await this.checkListAtividadeService.listar(atividade)
      .then(response => {
        this.setState({checkListLista: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Check List de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
  }

  renderFooterChekList(name) {
    return (
        <div>
            <Button label="Incluir" 
                    className="p-button-primary p-button-text"
                    onClick={this.incluirCheckList}/> 
            &nbsp;
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterCadastrarChekList(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarCheckList}/> 
            &nbsp;
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAlterarChekList(name) {
    return (
        <div>
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.alterarCheckList}/> 
            &nbsp;
            <Button label="Fechar" 
                   className="p-button-secondary p-button-text"
                   onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  acoesCheckList(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-text" 
                onClick={() => this.consultarTarefaCheckList(rowData)}
                tooltip="Editar tarefa de checklist" 
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmacaoExclusaoTarefaCheckList(rowData)} 
                tooltip="Excluir Tarefa de Checklist" 
                tooltipOptions={{position: 'top'}}/>
      </React.Fragment>
    );
  }

  consultarTarefaCheckList(tarefa) {
    this.setState({checkList: tarefa});
    this.setState({codigoCheckList: tarefa.codigo});
    this.setState({tarefaCheckList: tarefa.tarefa});
    this.setState({ordemChecklist: tarefa.ordem});
    this.setState({descricaoCheckList: tarefa.descricao});
    this.abrirModa('modalAlterarCheckList');  
  }

  alterarCheckList = async () => {
    if(this.state.ordemChecklist == '') {
      this.toast.show({severity:'error', summary: 'Check List de Atividades', detail:'Informe a ordem da tarefa', life: 4000});
      return;
    }

    if(this.state.tarefaCheckList == '') {
      this.toast.show({severity:'error', summary: 'Check List de Atividades', detail:'Informe a tarefa', life: 4000});
      return;
    }

    const checklist = {
      codigo: this.state.codigoCheckList,
      atividade: {
        codigo: this.state.codigo
      },
      ordem: this.state.ordemChecklist,
      tarefa: this.state.tarefaCheckList,
      descricao: this.state.descricaoCheckList
    }

    this.setState({openSpinner: true});
    await this.checkListAtividadeService.alterar(checklist)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Check List de Atividades', detail:'Ítem de Checklist alterado com sucesso', life: 4000});
        this.atualizarCheckList(this.state.codigo);
        this.fecharModal('modalAlterarCheckList');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Check List de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  confirmacaoExclusaoTarefaCheckList(tarefa) {
    this.setState({codigoCheckList: tarefa.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir a tarefa de checklist ?',
        header: 'Exclusão de Tarefa de Checklist',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirTarefaCheckList,
        reject: this.reject
    });
  }

  acceptExcluirTarefaCheckList = async () => {
    this.setState({openSpinner: true});
    await this.checkListAtividadeService.excluir(this.state.codigoCheckList)
      .then(response => {
        this.atualizarCheckList(this.state.codigo);
        this.toast.show({severity:'success', summary: 'Check List de Atividades', detail:'Tarefa de checklist excluída com sucesso', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Check List de Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarFases();
    await this.filtrarTitulos();
    //await this.listarTitulos();
    this.setState({openSpinner: false});
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          {/**Cadastro de Títulos de Atividades */}
          <Dialog header="Cadastro de Títulos de Atividades"
                    visible={this.state.modalTitulo} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroTitulos('modalTitulo')} 
                    onHide={() => this.fecharModal('modalTitulo')}>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeRito">Título da Tarefa</label>
                        <InputText id="nomeTitulo" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="faseProcesso">Fase</label>
                        <Dropdown value={this.state.faseProcesso} 
                                  options={this.state.fasesProcesso} style={{width: '100%', height: '32px'}}
                                  optionLabel="nome" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nome"
                                  onChange={e => this.setState({faseProcesso: e.target.value})}
                                  id="faseProcesso"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="pontos">Pontuação</label>
                        <InputText id="pontos" 
                                   type="text" 
                                   value={this.state.pontos}
                                   onChange={e => this.setState({pontos: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
          </Dialog>
          {/**Alterar Títulos de Atividades */}
          <Dialog header="Alterar Títulos de Atividades"
                    visible={this.state.modalTituloAlterar} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarTitulos('modalTituloAlterar')} 
                    onHide={() => this.fecharModal('modalTituloAlterar')}>
                
                <div className="row">
                  <div className="col-md-12">
                    <div className="formGroup">
                    <label htmlFor="nomeRito">Fase</label>
                      <Dropdown value={this.state.faseProcesso} 
                                options={this.state.fasesProcesso} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={e => this.setState({faseProcesso: e.target.value})}
                                id="faseCadastro"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="nomeTituloAlterar">Títilo da Tarefa</label>
                        <InputText id="nomeTituloAlterar" 
                                   type="text" 
                                   value={this.state.nome}
                                   onChange={e => this.setState({nome: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="pontosAlterar">Pontuação</label>
                        <InputText id="pontosAlterar" 
                                   type="text" 
                                   value={this.state.pontos}
                                   onChange={e => this.setState({pontos: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="formGroup">
                    <label htmlFor="nomeRito">Status</label>
                      <Dropdown value={this.state.status} 
                                options={this.status} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={e => this.setState({status: e.target.value})}
                                id="status"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
          </Dialog>
          {/**Fases de Atividade */}
          <Dialog header="Fases de Atividade"
                    visible={this.state.modalFase} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterFase('modalFase')} 
                    onHide={() => this.fecharModal('modalFase')}>
                
                <div className="row">
                  <div className="col-md-12">
                    <div className="formGroup">
                      <strong>{this.state.nome}</strong>
                    </div>
                  </div>
                </div>
                <br/>
                <div className="row">
                  <div className="col-md-12">
                    <div className="formGroup">
                      <Dropdown value={this.state.fase} 
                                options={this.state.fasesCadastro} style={{width: '100%', height: '32px'}}
                                optionLabel="nome" 
                                emptyMessage=" "
                                filter showClear filterBy="nome"
                                onChange={this.onChangeCadastrarFase}
                                id="fase"
                                placeholder="Selecionar fase para cadastro"
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
                <br/>
                <div className="row">
                  <div className="col-md-12">
                    <div className="formGroup">
                      <DataTable value={this.state.fases}  paginator responsiveLayout="scroll"
                                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                  currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" 
                                  emptyMessage="Nenhuma fase de atividade" 
                                  rows={5}
                                  size="small"
                                  header="Fases cadastrada para este Título">
                        <Column field="nome" header="Fase"></Column>
                        <Column body={this.acoesfase} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
          </Dialog>
          {/**Projeções de Usuários */}
          <Dialog header="Projeção por usuário"
                    visible={this.state.modalProjecao} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterProjecao('modalProjecao')} 
                    onHide={() => this.fecharModal('modalProjecao')}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="formGroup">
                        <InputText id="filtroNome" 
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.filtroNome}
                                   onChange={e => this.setState({filtroNome: e.target.value})}
                                   placeholder="Usuario"
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="formGroup">
                        <InputText id="filtroAno" 
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.filtroAno}
                                   onChange={e => this.setState({filtroAno: e.target.value})}
                                   placeholder="Ano"
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="formGroup">
                        <InputText id="filtroMes" 
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.filtroMes}
                                   onChange={e => this.setState({filtroMes: e.target.value})}
                                   placeholder="Mês"
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="formGroup">
                      <Button label="Filtrar" className="p-button-rounded p-button-text"
                              onClick={this.filtrarProjecoes} 
                              tooltip="Filtrar" 
                              tooltipOptions={{position: 'top'}}/>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <DataTable value={this.state.projecoes}  paginator responsiveLayout="scroll"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" 
                          emptyMessage="Nenhuma projeção caadstrada" 
                          rows={5}
                          size="small">
                          <Column field="usuario.nome" header="Usuário"></Column>
                          <Column field="ano" header="Ano"></Column>
                          <Column field="mes" header="Mês"></Column>
                          <Column field="pontos" header="Pontos"></Column>
                          <Column body={this.acoesProjecoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                        </DataTable>
                      </div>
                    </div>
                  </div>
          </Dialog>
          {/**cadastro de projeções */}
          <Dialog header="Projeção por usuário"
                    visible={this.state.modalCadastroProjecao} 
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastroProjecao('modalCadastroProjecao')} 
                    onHide={() => this.fecharModal('modalCadastroProjecao')}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label htmlFor="nomeRito">Usuário</label>
                        <Dropdown value={this.state.usuario} 
                                  options={this.state.usuarios} style={{width: '100%', height: '32px'}}
                                  optionLabel="nome" 
                                  emptyMessage=" "
                                  filter showClear filterBy="nome"
                                  onChange={e => this.setState({usuario: e.target.value})}
                                  id="faseCadastro"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="formGroup">
                        <label htmlFor="nomeRito">Ano</label>
                        <InputText id="ano" 
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.ano}
                                   onChange={e => this.setState({ano: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="formGroup">
                        <label htmlFor="nomeRito">Mês</label>
                        <InputText id="ano" 
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.mes}
                                   onChange={e => this.setState({mes: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="formGroup">
                        <label htmlFor="nomeRito">Pontos</label>
                        <InputText id="pontosProjecao" 
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.pontosUsuario}
                                   onChange={e => this.setState({pontosUsuario: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
          </Dialog>
          {/**Alterar projeção de usuário */}
          <Dialog header="Alterar Projeção de Usuário"
                    visible={this.state.modalAlterarProjecao}
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarProjecao('modalAlterarProjecao')} 
                    onHide={() => this.fecharModal('modalAlterarProjecao')}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <InputText id="usuarioAlterar" 
                                   disabled
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.usuarioNome}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="formGroup">
                        <label htmlFor="nomeRito">Ano</label>
                        <InputText id="ano" 
                                   type="text"
                                   disabled
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.ano}
                                   onChange={e => this.setState({ano: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="formGroup">
                        <label htmlFor="nomeRito">Mês</label>
                        <InputText id="ano" 
                                   type="text"
                                   disabled
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.mes}
                                   onChange={e => this.setState({mes: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="formGroup">
                        <label htmlFor="nomeRito">Pontos</label>
                        <InputText id="pontosProjecao" 
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.pontosUsuario}
                                   onChange={e => this.setState({pontosUsuario: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
          </Dialog>
          {/**CheckList de Atividades */}
          <Dialog header="Check List de Atividades"
                    visible={this.state.modalCheckList}
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterChekList('modalCheckList')} 
                    onHide={() => this.fecharModal('modalCheckList')}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <strong style={{color: 'blue', padding: '5px'}}>Tarefa: {this.state.nome}</strong>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <DataTable value={this.state.checkListLista}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhum Check List encontrado" rows={10}>
                      <Column field="ordem" header="Ordem"></Column>
                      <Column field="tarefa" header="Tarefa"></Column>
                      <Column field="descricao" header="Descrição"></Column>
                      <Column body={this.acoesCheckList} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                  </DataTable>
          </Dialog>
          {/**Cadastrar Check Lista de Atividade */}
          <Dialog header="Check List de Atividades"
                    visible={this.state.modalCadastrarCheckList}
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterCadastrarChekList('modalCadastrarCheckList')} 
                    onHide={() => this.fecharModal('modalCadastrarCheckList')}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <strong style={{color: 'blue', padding: '5px'}}>Tarefa: {this.state.nome}</strong>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label>Ordem</label>
                        <InputText id="ordemCheckList" 
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.ordemChecklist}
                                   onChange={e => this.setState({ordemChecklist: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label>Tarefa</label>
                        <InputText id="tarefaCheckList" 
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.tarefaCheckList}
                                   onChange={e => this.setState({tarefaCheckList: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label>Descrição</label>
                        <InputTextarea id="descricaoCheckList" 
                                      rows={7}
                                      cols={30}
                                      autoResize
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.descricaoCheckList}
                                      onChange={e => this.setState({descricaoCheckList: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
          </Dialog>
          {/**Alterar Check Lista de Atividade */}
          <Dialog header="Check List de Atividades"
                    visible={this.state.modalAlterarCheckList}
                    style={{ width: '40vw' }} 
                    footer={this.renderFooterAlterarChekList('modalAlterarCheckList')} 
                    onHide={() => this.fecharModal('modalAlterarCheckList')}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label>Ordem</label>
                        <InputText id="ordemCheckList" 
                                   type="text"
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.ordemChecklist}
                                   onChange={e => this.setState({ordemChecklist: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label>Tarefa</label>
                        <InputText id="tarefaCheckList" 
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.tarefaCheckList}
                                   onChange={e => this.setState({tarefaCheckList: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="formGroup">
                        <label>Descrição</label>
                        <InputTextarea id="descricaoCheckList" 
                                      rows={7}
                                      cols={30}
                                      autoResize
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.descricaoCheckList}
                                      onChange={e => this.setState({descricaoCheckList: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
          </Dialog>
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="pi pi-tablet"></i>
                        <span> Títulos de Atividades</span>
                      </h3>  
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-5">
                          <span className="input-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={this.telaTituloAtividade}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="pi pi-check-square"></i> Adicionar</button>
                            &nbsp;
                            &nbsp;
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                    onClick={this.consultarProjecoes}
                                    data-toggle="modal" 
                                    data-target="#modal-default">
                            <i className="pi pi-user"></i> Projeção por usuário</button>
                          </span>
                        </div>
                      </div>
                      <br></br>
                      <div className="row">
                        <div className="col-md-2">
                          <div className="formGroup">
                            <Dropdown value={this.state.filtroFase} 
                                      options={this.state.fasesProcesso} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={this.onChangeConsultarTitulosPorFase}
                                      id="fase"
                                      placeholder="Fase"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="formGroup">
                            <Dropdown value={this.state.filtroStatus} 
                                      options={this.status} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={this.onChangeConsultarTitulosPorStatus}
                                      id="status"
                                      placeholder="Status"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="formGroup">
                            <InputText id="filtroNome" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.filtroNome}
                                    onKeyPress={event => event.key === 'Enter' && this.consultarPorTitulo()}
                                    onChange={e => this.setState({filtroNome: e.target.value})}
                                    placeholder="Título"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="formGroup">
                            <Dropdown value={this.state.classificacao} 
                                      options={this.classificacao} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={this.onChangeConsultarTitulosPorClassificacao}
                                      id="classificacao"
                                      placeholder="Classificação"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="formGroup">
                            <Dropdown value={this.state.ordenacao} 
                                      options={this.ordenacao} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={this.onChangeConsultarTitulosPorOrdenacao}
                                      id="ordenacao"
                                      placeholder="Ordenação"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.titulos}  paginator responsiveLayout="scroll"
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" emptyMessage="Nenhum título encontrado" rows={10}>
                      <Column field="titulo" header="Nome"></Column>
                      <Column field="fase.nome" header="Fase Processual"></Column>
                      <Column field="pontos" header="Pontuação"></Column>
                      <Column field="status" header="Status"></Column>
                      <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

TituloAtividade.contextType = AuthContext;
export default withRouter (TituloAtividade)